'use es6';

import { initLayoutBuilder } from 'LayoutBuilderUI/actions/ApiActions';
import ApplicationDnd from 'LayoutBuilderUI/components/ApplicationDnd';
import RenderedModuleModel from 'EmailEditorUI/data/models/RenderedModuleModel';
import { startApp, mountApplicationWithErrorHandling, initAppEssentials } from 'LayoutBuilderUI/utils/appUtils';
import { mapFlexAreaModules } from 'LayoutBuilderUI/utils/prerenderingUtils';

// Conditional selector stats require (to not include extra code in normal builds)
// eslint-disable-next-line no-undef
if (typeof SELECTOR_STATS !== 'undefined' && SELECTOR_STATS) {
  require('LayoutBuilderUI/debugging/attach-selector-stats');
}
class AppDnd {
  constructor() {
    this.parentAppReady = false;
    this.renderApp = initData => {
      const {
        metaData,
        initialSyncState
      } = initData;
      const renderedModules = {};
      const renderedModulesForParent = {};
      const moduleWrapperIdPrefix = 'hs_cos_wrapper_';
      mapFlexAreaModules(el => {
        const moduleId = el.id.substring(moduleWrapperIdPrefix.length);
        renderedModules[moduleId] = RenderedModuleModel.from(moduleId, el.outerHTML);
        renderedModulesForParent[moduleId] = {
          html: el.outerHTML
        };
      });
      const brandingSection = document.getElementById('section_hubspot_brand');
      if (brandingSection) {
        renderedModules.brandingSection = RenderedModuleModel.from('brandingSection', brandingSection.outerHTML);
        renderedModulesForParent.brandingSection = {
          html: brandingSection.outerHTML
        };
      }
      this.eventBus.onI18nReady(I18nProvider => {
        const layoutBuilderAppDomEl = document.getElementById('hs_cos_wrapper_main');
        mountApplicationWithErrorHandling(ApplicationDnd, {
          bus: window.LayoutBuilderUI.messenger,
          initialSyncState,
          renderedModules,
          ctas: metaData.ctas,
          socialNetworks: metaData.socialNetworks,
          isNewEmail: metaData.isNewEmail,
          schema: initialSyncState.contentSchema && initialSyncState.contentSchema.schema,
          I18nProvider
        }, layoutBuilderAppDomEl, renderedModulesForParent);
      });
    };
  }
  initialize() {
    if (document.location.origin === null) {
      document.location.origin = `${document.location.protocol}//${document.location.hostname}`;
    }
    this.initApp = this.initApp.bind(this);
  }
  start() {
    if (window.jasmine) return;
    window.AppInstance = this;
    this.eventBus = window.LayoutBuilderUI.messenger;
    this.eventBus.onAppReady(this.initApp);
  }
  initApp() {
    // avoid multiple init of the in case multiple replies from the parent app
    if (!this.parentAppReady) {
      this.parentAppReady = true;
      initLayoutBuilder(initData => {
        initAppEssentials(initData, 'DRAG_AND_DROP');
        if (document.readyState !== 'loading') {
          this.renderApp(initData);
        } else {
          document.addEventListener('readystatechange', () => this.renderApp(initData), {
            once: true
          });
        }
      });
    }
  }
}
startApp(AppDnd);